var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 11,
    viewBox: "0 0 23 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94975 0.292893C5.55922 -0.0976311 4.92606 -0.0976311 4.53553 0.292893L0.292893 4.53553C0.244078 4.58435 0.201364 4.63696 0.164752 4.69241C-0.0915291 5.08056 -0.0488155 5.60804 0.292893 5.94975L4.53553 10.1924C4.92606 10.5829 5.55922 10.5829 5.94975 10.1924C6.34027 9.80186 6.34027 9.1687 5.94975 8.77818L3.41422 6.24264H21.2426C21.7949 6.24264 22.2426 5.79493 22.2426 5.24264C22.2426 4.69036 21.7949 4.24264 21.2426 4.24264H3.41421L5.94975 1.70711C6.34027 1.31658 6.34027 0.683417 5.94975 0.292893Z",
    fill: "#96232B",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.563b33277f77a94cfead905af44f40a8.svg";
export { ForwardRef as ReactComponent };